module.exports = __webpack_public_path__ + "img/en.89d8d23f.svg";